import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  imgIcon: { width: theme.spacing(4), height: theme.spacing(4) },
}));
